export const DashboardEndpoints = {
    getOverview: {
        method: "get",
        url: "/dashboard/overview",
    }
}
